
import { Vue } from "vue-class-component";

export default class Table extends Vue {
  
}
